var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlutenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 120.2 125.4",
    enableBackground: "new 0 0 120.2 125.4",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E622",
    d: "M12.4,90.5c3.8,6.5,9.4,11.8,16,16.1c9.8,6.4,20.5,10.8,32.4,10.7c1.3,0,2.6-0.1,3.9-0.2 c0.2,0.2,0.7,0.2,0.8-0.1c8.9-0.9,17.7-3.9,25.3-8.7c9.9-6.2,17-14.6,20.6-25.7c3.7-11.6,4.3-24.3,1-36.1 C105.7,23.3,83,5.5,58.2,8.3c-0.1-0.2-0.3-0.2-0.6-0.2c-22.6,2.4-41,18.7-47.8,40.1c-0.8,2.7-1.5,5.4-2,8.2 c-0.2,0.1-0.3,0.4-0.1,0.5c-0.2,1-0.3,2-0.4,3c-0.1,0.1-0.1,0.2,0,0.3C6.3,67.5,6.7,75,8.7,82c0.8,2.9,2,5.6,3.4,8.1 C12.1,90.2,12.2,90.5,12.4,90.5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 51.8727,
    y1: 60.7718,
    x2: 114.3488,
    y2: 81.2886
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04064121,
    style: {
      stopColor: "#958D1C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3291,
    style: {
      stopColor: "#C2B81E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5766,
    style: {
      stopColor: "#E4D920"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7188,
    style: {
      stopColor: "#F1E622"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M48.5,98.1l37,13.1c1.8-0.9,3.5-1.8,5.2-2.9c9.9-6.2,17-14.6,20.6-25.7c3.4-10.7,4.2-22.4,1.7-33.4 L73.7,28.6L48.5,98.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M64.2,57.1c-0.1-1.5,0-3,0.4-4.5c0.5-1.8,1.5-3.6,3.2-4.2c1.1-0.3,2.3,0,3.4-0.1c2.3-0.1,4.5-2,5.1-4.3 c-0.1,1.7,0.3,3.4,0.2,5.1c-0.1,1.7-0.7,3.4-1.7,4.8c-0.4,0.5-0.8,1-1.4,1.4c-1.2,0.8-2.7,0.9-4.1,1c-1.4,0.1-2.9,0.4-3.9,1.4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M60.2,68c0-1.5,0.4-3,0.9-4.4c0.7-1.7,1.9-3.5,3.6-3.7c1.1-0.2,2.2,0.3,3.4,0.3c2.3,0.2,4.7-1.4,5.6-3.7 c-0.2,1.7-0.1,3.4-0.4,5.1c-0.3,1.7-1.1,3.3-2.2,4.5c-0.4,0.5-0.9,0.9-1.5,1.2c-1.3,0.6-2.7,0.5-4.1,0.5s-2.9,0-4,1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M56.6,77.8c0.1-1.5,0.5-3,1.1-4.4c0.7-1.7,2-3.4,3.8-3.6c1.1-0.1,2.2,0.4,3.3,0.5c2.3,0.3,4.8-1.2,5.7-3.4 c-0.3,1.7-0.2,3.4-0.6,5.1c-0.4,1.7-1.2,3.2-2.4,4.4c-0.5,0.5-1,0.9-1.6,1.2c-1.3,0.6-2.8,0.4-4.2,0.3c-1.4-0.1-2.9-0.1-4.1,0.8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M52.9,87.4c0.2-1.5,0.7-3,1.4-4.3c0.8-1.6,2.2-3.2,4-3.3c1.1-0.1,2.2,0.5,3.3,0.7c2.3,0.4,4.8-0.9,5.9-3.1 c-0.4,1.6-0.4,3.4-0.9,5c-0.5,1.6-1.4,3.1-2.7,4.3c-0.5,0.4-1,0.8-1.6,1.1c-1.3,0.5-2.8,0.2-4.2,0c-1.4-0.2-2.9-0.3-4.1,0.5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M61.7,56.2c1-1.1,1.9-2.4,2.5-3.8c0.7-1.7,1.1-3.8,0.1-5.2c-0.7-0.9-1.8-1.4-2.6-2.2 c-1.8-1.6-2.3-4.4-1.3-6.6c-1,1.4-2.3,2.5-3.3,3.8c-1,1.4-1.5,3.1-1.6,4.8c0,0.7,0,1.3,0.2,2c0.4,1.4,1.6,2.3,2.6,3.3 c1,1,2,2.1,2.2,3.5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M58,67.2c0.9-1.2,1.6-2.6,2.1-4c0.5-1.8,0.7-3.9-0.5-5.2c-0.8-0.8-1.9-1.2-2.8-1.8c-1.9-1.3-2.8-4-2.1-6.3 c-0.8,1.5-2.1,2.7-2.9,4.2c-0.8,1.5-1.2,3.2-1.1,4.9c0,0.7,0.2,1.3,0.4,1.9c0.6,1.3,1.8,2.1,3,2.9c1.1,0.8,2.3,1.8,2.6,3.2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M54.7,77.2c0.8-1.3,1.5-2.7,1.9-4.1c0.5-1.8,0.5-3.9-0.8-5.2c-0.8-0.8-2-1.1-2.9-1.7c-2-1.2-3-3.9-2.4-6.2 c-0.8,1.5-1.9,2.8-2.7,4.3c-0.7,1.5-1,3.3-0.8,5c0.1,0.7,0.2,1.3,0.5,1.9c0.7,1.3,1.9,2,3.1,2.8c1.2,0.8,2.4,1.7,2.7,3.1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M51.8,87c0.8-1.3,1.3-2.8,1.6-4.2c0.4-1.8,0.2-3.9-1.1-5.1c-0.9-0.7-2-1-3-1.5c-2.1-1.1-3.2-3.7-2.7-6.1 c-0.7,1.6-1.8,2.9-2.4,4.5c-0.6,1.6-0.8,3.3-0.5,5c0.1,0.6,0.3,1.3,0.6,1.8c0.7,1.2,2,1.9,3.3,2.6c1.2,0.7,2.5,1.6,2.9,2.9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M67.1,46.9c1.3-1.3,2.6-2.6,3.7-4.1c1-1.5,1.8-3.4,1.9-5.2 c0-1.6-0.5-3.1-0.8-4.7c-0.3-1.5-0.1-3.3,0.4-4.7c-0.3,1.3-1.2,3.1-2.5,4.1c-1.2,1-2.6,1.8-3.6,3.1c-1.3,1.6-1.9,3.8-1.8,5.8 c0.1,2,0.8,3.9,1.8,5.6L49.2,97.8c0,0,3.2-7.2-3.4-10.8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M67.1,47.3c1.3-1.3,2.6-2.6,3.7-4.1c1-1.5,1.8-3.4,1.9-5.2c0-1.6-0.5-3.1-0.8-4.7c-0.3-1.5-0.1-3.3,0.4-4.7 c-0.3,1.3-1.2,3.1-2.5,4.1c-1.2,1-2.6,1.8-3.6,3.1c-1.3,1.6-1.9,3.8-1.8,5.8c0.1,2,0.8,3.9,1.8,5.6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlutenIcon);
export default __webpack_public_path__ + "static/media/gluten_icon.20d668b468837848ad36114e59e36f87.svg";
export { ForwardRef as ReactComponent };